export function submitGuestPost() {
    const { title, description, email, name, bio, site, newsletter, feedback } = getPostValues();
    const theForm = document.getElementById("guest_post");
    const messageEl = theForm.querySelector(".final-message");

    const loader = document.createElement("i");
    loader.className = "fa fa-spinner fa-pulse";

    messageEl.appendChild(loader);
    messageEl.classList.add("show");

    jQuery.ajax({
        url: guestPostJs.ajax_url,
        type: "post",
        data: {
            action: "guest_post_ajax",
            nonce: guestPostJs.ajax_nonce,
            title,
            description,
            email,
            name,
            bio,
            site,
            newsletter,
            feedback,
        },
        success: function(response) {
            const responseJson = JSON.parse(response);

            messageEl.removeChild(loader);
            messageEl.innerHTML = `
            Thank you for your post. We will be in touch with any questions.
            <div>
                <hr>
                <b>Follow us:</b>
                <ul class="social-hover">
                    <li><a href="https://facebook.com/CMNHospitals" target="_blank"><span class="fa-stack fa-lg facebook"><i class="fa fa-facebook fa-stack-1x"></i></span></a></li>
                    <li><a href="https://twitter.com/CMNHospitals" target="_blank"><span class="fa-stack fa-lg twitter"><i class="fa fa-twitter fa-stack-1x"></i></span></a></li>
                    <li><a href="https://www.instagram.com/cmnhospitals/" target="_blank"><span class="fa-stack fa-lg instagram"><i class="fa fa-instagram fa-stack-1x"></i></span></a></li>
                    <li><a href="https://www.snapchat.com/add/cmnhospitals" target="_blank"><span class="fa-stack fa-lg"><i class="fa fa-snapchat-ghost fa-stack-1x"></i></span></a></li>
                    <li><a href="https://www.youtube.com/user/cmnhospitals" target="_blank"><span class="fa-stack fa-lg youtube"><i class="fa fa-youtube fa-stack-1x"></i></span></a></li>
                    <li><a href="https://www.linkedin.com/company/cmnhospitals" target="_blank"><span class="fa-stack fa-lg linkedin"><i class="fa fa-linkedin fa-stack-1x"></i></span></a></li>
                </ul>
            </div>`;
            messageEl.className = "final-message show";
            return responseJson;
        },
        error: function() {
            messageEl.innerHTML = "Oops. Something went wrong. Please try again or contact guestpost@cmnhospitals.org";
            messageEl.className = "final-message show alert alert-danger";
            theForm.querySelector(".guest-post-inner").classList.remove("hide");

            /* global grecaptcha */
            grecaptcha.reset();

            return false;
        },
    });
}

function getPostValues() {
    const title = document.querySelector(".js-title").value;
    const description = document.querySelector(".js-description").value;
    const email = document.querySelector(".js-email").value;
    const name = document.querySelector(".js-name").value;
    const bio = document.querySelector(".js-bio").value;
    const site = document.querySelector(".site-dropdown-input").value;
    const feedback = document.querySelector(".js-feedback").value;
    let newsletter = document.querySelector(".js-checkbox:checked");

    if (newsletter) {
        newsletter = true;
    } else {
        newsletter = false;
    }

    return { title, description, email, name, bio, site, newsletter, feedback };
}
